<template>
  <div>
    <h2>系统消息</h2>
    <div class="list">
        <div v-for="(item,index) in list" :key="index">{{item.offMessage.mailContent}}</div>
    </div>

	<hxlPagin :queryParams="queryParams" @changePage="changePage"/>

  </div>
</template>

<script>
import { logininfor } from '@/api/personalCenter.js';
import hxlPagin from "@/components/hxlPagin"; 
export default {
	components:{hxlPagin},
	data(){
		return{

			list:[],

			queryParams:{
				pageNum:1,
				pageSize:10,
				total: 100,
			}
		}
	},
	created () {
        this.getList();
    },
	methods:{
		changePage (e) { this.queryParams.pageNum = e; this.getList(); },
		getList(){
			logininfor(this.queryParams).then(res=>{
				this.list = res.rows
				this.queryParams.total = res.total
			})
		},
	}
}
</script>

<style lang="scss" scoped>
    .list{
        border: 1px solid rgba(0,0,0,.2);
        border-bottom: 0;
        >div{
            padding: 15px; 
            border-bottom: 1px solid rgba(0,0,0,.2);
        }
    }
</style>